import {
  Component,
  OnChanges,
  OnInit,
  SimpleChanges,
  input,
  output
} from '@angular/core';
import { SliderComponent } from '@imagise/shared';
import { TranslateModule } from '@ngx-translate/core';
import { EditorBackendFilterArgs } from '../../../../domain';

export interface BackendFilterOptionsConfig {
  showAngle?: boolean;
  showSigma?: boolean;
  showSize?: boolean;
  defaultAngle?: number;
  defaultSigma?: number;
  defaultSize?: number;
}

@Component({
  selector: 'lib-backend-filter-options',
  templateUrl: './backend-filter-options.component.html',
  imports: [SliderComponent, TranslateModule],
})
export class BackendFilterOptionsComponent implements OnInit, OnChanges {
  readonly config = input<BackendFilterOptionsConfig | null>(null);

  readonly filterArgsChanged = output<EditorBackendFilterArgs>();

  size = 3;
  sigma = 1;
  angle = 0;

  ngOnInit(): void {
    this.resetValuesFromConfig();
    this.emitArgs();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['config'] || changes['config'].firstChange) {
      return;
    }

    this.resetValuesFromConfig();
    this.emitArgs();
  }

  onSizeChanged(value: number): void {
    if (this.size === value) {
      return;
    }

    this.size = value;
    this.emitArgs();
  }

  onSigmaChanged(value: number): void {
    if (this.sigma === value) {
      return;
    }

    this.sigma = value;
    this.emitArgs();
  }

  onAngleChanged(value: number): void {
    if (this.angle === value) {
      return;
    }

    this.angle = value;
    this.emitArgs();
  }

  private resetValuesFromConfig(): void {
    this.size = this.config()?.defaultSize ?? 3;
    this.sigma = this.config()?.defaultSigma ?? 1;
    this.angle = this.config()?.defaultAngle ?? 0;
  }

  private emitArgs(): void {
    this.filterArgsChanged.emit({
      kind: 'backend-filter',
      size: this.config()?.showSize ? this.size : null,
      sigma: this.config()?.showSigma ? this.sigma : null,
      angle: this.config()?.showAngle ? this.angle : null,
    });
  }
}
